import Marionette from "backbone.marionette";
import $ from "jquery";

import { heapTrack } from "lib/analytics";
import { AUTH_CODE_TYPE } from "lib/constants";
import { formatPhone, redirect } from "lib/util";

import loginCodeTemplate from "../../templates/components/auth/auth-login-code.jst";

const LoginCodeComponent = Marionette.View.extend({
    template: loginCodeTemplate,

    ui: {
        btnSubmit: ".js-submit",
        containerDefault: ".js-default",
        containerSent: ".js-code-sent",
        error: ".error",
        inputCode: "input[name=code]",
        linkResend: ".js-resend",
        resendConfirm: ".auth__resend-confirm",
        verifyEmail: ".js-email",
        verifyPhone: ".js-phone",
    },

    events: {
        "click @ui.linkResend": "onResendCode",
        "click @ui.btnSubmit": "onEnterCode",
        "click .js-send-phone": "onSendPhone",
        "click .js-send-email": "onSendEmail",
    },

    serializeData() {
        const phone = this.model.get("phone");
        const email = this.model.get("email");
        const codeType = this.model.getHandleType();

        return {
            phone: phone ? formatPhone(phone) : null,
            email,
            isMobile: codeType === AUTH_CODE_TYPE.MOBILE,
            isEmail: codeType === AUTH_CODE_TYPE.EMAIL,
            handle: this.model.getFormattedHandle(),
            verify: !!this.options.verify,
        };
    },

    onSendPhone(event) {
        this.sendCode(AUTH_CODE_TYPE.MOBILE, $(event.currentTarget));
    },

    onSendEmail(event) {
        this.sendCode(AUTH_CODE_TYPE.EMAIL, $(event.currentTarget));
    },

    sendCode(codeType, $btn, resend = false) {
        $btn.loading(true);

        this.codeType = codeType;
        this.codeBtn = $btn;

        return $.ajax({
            type: "POST",
            url: "/api/hire/v1/auth/code/",
            data: JSON.stringify({
                code_type: codeType,
                handle: this.model.getHandle(),
                csrf_token: window.csrfToken,
            }),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                heapTrack("Auth Code - Send Success", {
                    codeType,
                    resend,
                });

                this.sendTime = new Date();

                if (codeType === AUTH_CODE_TYPE.MOBILE) {
                    this.ui.verifyPhone
                        .show()
                        .find("strong")
                        .text(formatPhone(this.model.get("phone")));
                } else {
                    this.ui.verifyEmail.show().find("strong").text(this.model.get("email"));
                }

                this.ui.containerDefault.hide();
                this.ui.containerSent.show();
                this.ui.inputCode.focus();

                this.trigger("code:sent");
            })
            .fail((response) => {
                heapTrack("Auth Code - Send Fail", {
                    codeType,
                    resend,
                    status: response.status,
                });

                this.showError("Unfortunately, something went wrong. Please refresh the page.");
            })
            .always(() => {
                $btn.loading(false);
            });
    },

    onResendCode(event) {
        event.preventDefault();

        this.sendCode(this.codeType, this.codeBtn, true).done(() => {
            this.ui.linkResend.fadeOut(() => {
                this.ui.resendConfirm.fadeIn();
            });
        });
    },

    onEnterCode() {
        const code = this.ui.inputCode.val().trim();
        if (!code) {
            this.showError("Please enter a code.");
            return;
        }

        this.ui.btnSubmit.loading(true);

        $.ajax({
            type: "POST",
            url: "/api/hire/v1/auth/code/verify/",
            data: JSON.stringify({
                code,
                code_type: this.codeType,
                handle: this.model.getHandle(),
                csrf_token: window.csrfToken,
            }),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                const elapsedMS = new Date() - this.sendTime;
                heapTrack("Auth Code - Enter Success", {
                    codeType: this.codeType,
                    elapsedMS,
                });

                redirect(this.model.redirectUrl());
            })
            .fail((response) => {
                let errorMsg = null;

                if (response.status === 403) {
                    errorMsg = response.responseJSON.error;
                    this.showError(errorMsg);
                }

                const elapsedMS = new Date() - this.sendTime;
                heapTrack("Auth Code - Enter Fail", {
                    codeType: this.codeType,
                    error: errorMsg,
                    status: response.status,
                    elapsedMS,
                });
            })
            .always(() => {
                this.ui.btnSubmit.loading(false);
            });
    },

    showError(text) {
        this.ui.error.text(text);
    },
});

export default LoginCodeComponent;
